var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCheckmarkCircle = function SvgCheckmarkCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#25D091"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.06 11.692-.105-.104-.106.104-.954.94-.109.107.109.107 3.818 3.76.105.105.105-.104 8.182-8.06.109-.107-.109-.107-.954-.94-.105-.104-.106.104-7.122 7.016-2.758-2.717Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  })));
};

export default SvgCheckmarkCircle;